export default __webpack_public_path__ + "static/media/16-clustering.60b71d16.svg";